import { productTaxonomyDisplayOptions } from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/SizingWidgetConfigurationPage/SizingWidgetConfiguration/ProductOptions/constants'
import { getEmptyTranslations } from '@/configuration/pages/ConfigurationPage/helpers'

export const getEditPreferencesPayload = ({
  backgroundColor,
  textColor,
  useCustomTextTooBig,
  useCustomTextTooSmall,
  customTextTooBig,
  customTextTooSmall,
  supportedLanguages,
  productTaxonomyDisplay,
  productTaxonomyIds,
}) => {
  const emptyTranslations = getEmptyTranslations(supportedLanguages)
  return {
    background_color: backgroundColor,
    text_color: textColor,
    too_big_text: useCustomTextTooBig ? customTextTooBig : emptyTranslations,
    too_small_text: useCustomTextTooSmall ? customTextTooSmall : emptyTranslations,
    product_taxonomy_display: productTaxonomyDisplay,
    product_taxonomy_ids: productTaxonomyDisplay === productTaxonomyDisplayOptions.all ? [] : productTaxonomyIds,
  }
}
